export default {
  edit (aModel) {
    this.editRelation('deceaseds', aModel)
  },

  delete (aModel) {
    this.deleteRelation('deceaseds', aModel)
  }
}



// WEBPACK FOOTER //
// ./src/functions/deceased.js